/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-alert */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { FC, useState } from 'react';
import { useTranslations } from 'next-intl';
import BigNumber from 'bignumber.js';

import * as Styles from '@components/modals/styles';
import { ILooseObject } from '@interface/loose-object';
import { auctionBid } from '@lib/beacon';
import { MutToTez, TezToMut } from '@utils/format';
import { testNodeHealth } from '@utils/node';
import { AlertDialog, Field, Input } from '@versumstudios/ui';

export interface IAuctionBid {
  open?: boolean;
  onOpenChange?: (value: boolean) => void;
  auctionId?: number;
  currentBid?: number;
  isMinBid?: boolean;
}

export const AuctionBid: FC<IAuctionBid> = ({ open, onOpenChange, auctionId, currentBid, isMinBid }) => {
  const t = useTranslations('market');
  const [values, setValues] = useState<ILooseObject>({
    bid: { error: false, data: null },
  });

  const minBidValue = isMinBid ? currentBid : new BigNumber(currentBid!).times(1.1).toNumber();

  const handleChange = (key: string, value: any) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: false, data: value },
    }));
  };

  const setError = (key: string, message: string) => {
    setValues((prevValues) => ({
      ...prevValues,
      [key]: { error: message, data: prevValues[key].data },
    }));
  };

  const validate = () => {
    let valid = true;

    if (!values.bid.data) {
      setError('bid', '"Bid" is missing');
      valid = false;
    }

    if (values.bid.data !== null && currentBid !== undefined && minBidValue !== undefined) {
      if (TezToMut(values.bid.data) < minBidValue) {
        setError('bid', `Min "Bid" value ${MutToTez(minBidValue)} tez`);
        valid = false;
      }
    }

    return valid;
  };

  const handleConfirm = async () => {
    if (validate()) {
      await testNodeHealth();
      auctionBid(auctionId!, Number(values.bid.data));

      if (onOpenChange) {
        onOpenChange(false);
      }
    }
  };

  const handleCancel = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  return (
    <AlertDialog
      title={t('bid')}
      description={`You're about to bid on this token. Your bid needs to be 10% over the current bid (${MutToTez(
        minBidValue!
      )} tez).`}
      open={open}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
    >
      <Styles.Content>
        <Field
          uid="bid"
          label="Your Bid"
          tooltip="Your bid needs to be 10% over the last successful bid."
          error={values.bid.error}
        >
          <Input
            type="number"
            min={0}
            max={10}
            placeholder="e.g.: 3.5"
            onChange={(value: string) => handleChange('bid', value)}
          />
        </Field>
      </Styles.Content>
    </AlertDialog>
  );
};
